<div class="auth login d-flex">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">

        <div class="login-header text-center">
          <img src="/assets/img/videobyte-logo.svg" alt="" width="200"/>
        </div>

        <div class="login-content">
          <mat-card class="p-5 mb-5">
            <mat-card-title class="mb-4 pb-3 text-center">
              <i class="fal fa-warning fa-3x mb-3 d-block text-primary" aria-hidden="true"></i>
              <strong>Forgot Password</strong>
              <small class="row mt-3 justify-content-center"> Enter your email and we will send you a link to reset your password.</small>
            </mat-card-title>
            <mat-card-content>
              <div>
                <form #f="ngForm" class="d-flex flex-column">
                  <mat-form-field floatLabel="" class="mb-2" appearance="outline">
                    <mat-label>Email</mat-label>
                    <input #email
                           matInput
                           placeholder="Registered email address"
                           name="email" value=""
                           required
                           email
                           [(ngModel)]="userEmail"
                           (keyup.enter)="f.valid && forgotPasswordMail()">
                  </mat-form-field>
                </form>
              </div>
            </mat-card-content>
            <mat-card-footer class="text-center">
              <button type="button" mat-flat-button color="primary" class="iconed large" (click)="forgotPasswordMail()"
                      [disabled]="!f.valid">
                <span>Submit</span>
              </button>
            </mat-card-footer>
          </mat-card>

          <small class="d-block text-center text-white mt-n3">
            <p class=" hand" (click)="navigateToLogin()">Back to Login</p>
          </small>

        </div>

      </div>
    </div>
  </div>
</div>
